import React, { useContext, FC } from "react";
import { Link } from "react-router-dom";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import InviteUserTable from "./tables/InvitUserTable";
import { SidebarContext } from "../../auth/ProtectedRoute";

const InviteNewUsers: FC = () => {
  const { userName, sidebarData } = useContext(SidebarContext);
  return (
    <div className="user">
      <div className="user__edit">
        <div className="user__edit--heading">
          <h1>Invite Users</h1>
          <Link
            to="add-new-invite"
            state={{ userName: userName, sidebar: sidebarData }}
          >
            <button>+ Invite New User</button>
          </Link>
        </div>
      </div>
      <div className="user__middle">
        <div className="user__middle-search">
          <Input
            size="large"
            placeholder="Search List"
            prefix={<SearchOutlined />}
            className="input"
          />
        </div>
      </div>
      <div>
        <InviteUserTable />
      </div>
    </div>
  );
};

export default InviteNewUsers;
